import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Tag } from 'antd';

import { pageSectionTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';

const height = window.innerHeight * .74;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const dueGetter = (params) => {
    return params.data.Total - params.data.Advance;
};

const columnDefs = [
    { headerName: 'Branch', field: 'BranchId', type: 'numericColumn' },
    { headerName: 'Branch Name', field: 'BranchName' },
    { headerName: 'Lab Name', field: 'LabName' },
    { headerName: 'Total Bill Amount', field: 'Total', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Received', field: 'Advance', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Due', field: 'Due', valueGetter: dueGetter, type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
];

class ReceivableGrid extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    countTag = () => {
        if (this.store.isDone) {
            return (
                <>
                    <Tag color="#108ee9">{this.store.rowCount} Rows</Tag>
                    <Tag color="geekblue"> {this.store.totalReceivableSum} Total Receivable </Tag>
                </>
            )
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }

    fetchReceivableSummary = () => {
        this.store.fetchReceivableSummary();
    }

    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        const referrerId = selectedRows[0].ReferrerId;
        const labName = selectedRows[0].LabName;
        console.log(labName)
        const collectionType = this.store.collectionType;

        const params = { parentKey: "receivables", referrerId, labName, collectionType };

        this.props.appStore.currentComponent = { label: "Lab Summary", key: "labSummary", params: params };
    }

    render() {

        const receivables = this.store.receivables;

        return (
            <PageHeader style={{ paddingTop: 0 }} title={pageSectionTitle(this.props.title)} tags={this.countTag()}>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={receivables}
                        rowSelection={'single'}
                        onSelectionChanged={this.onSelectionChanged}
                        columnDefs={columnDefs}
                        onGridReady={this.fetchReceivableSummary}>
                    </AgGridReact>
                </div>
            </PageHeader>
        )
    }
}

export default observer(ReceivableGrid)
